<template>
  <label class="outside-label">{{ title }}</label>
</template>

<script>
import { getContactDetailsTitle } from "@/services/orderPageSectionTitles";

export default {
  name: "CheckoutContactTitle",
  computed: {
    title() {
      return getContactDetailsTitle(this.$i18n?.locale);
    },
  },
};
</script>
